import { Extension } from "@tiptap/core";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light-border.css";
import "./TokenSuggestion.css";

import { createSuggestionPlugin } from "./token/plugin";
import { getContextData, registerContextData, extractPaths } from "./token/contextRegistry";
import { PathMetadata } from "./token/types";

export { getContextData, registerContextData, extractPaths };
export type { PathMetadata };

export const TokenSuggestion = Extension.create({
    name: "tokenSuggestion",

    addProseMirrorPlugins() {
        return [createSuggestionPlugin(this.editor)];
    },
});
